import { useAuthState } from "react-firebase-hooks/auth";
import { useQuery } from "react-query";
import auth from "../firebase.init";

const API_BASE = process.env.REACT_APP_apiHostLink;

export const useAdminAuth = () => {
  const [user, loading, error] = useAuthState(auth);

  const {
    data: donorData,
    isLoading: donorLoading,
  } = useQuery(
    ["admin-check", user?.email],
    async () => {
      const token = await user.getIdToken();
      const res = await fetch(`${API_BASE}/api/v1/donors/${user.email}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.json();
    },
    { enabled: !!user?.email, retry: false }
  );

  const role = donorData?.role;

  return {
    user,
    loading: loading || donorLoading,
    error,
    role,
    isAdmin: role === "admin" || role === "super_admin",
    isSuperAdmin: role === "super_admin",
    donorData,
  };
};
